<template>
  <section class="sponsors-section">
    <h2 class="text-center text-uppercase">
      <i class="fas fa-square"></i>
      {{ $t("exhibitors") }}
    </h2>
    <div v-for="category in categories" :key="category">
      <h3 class="text text-upper sponsor-group-text">
        <i class="fas fa-square"></i>
        {{ $t("category") }} {{ category }}
      </h3>
      <div
        class="premium-sponsor-images"
        v-for="booth in getBoothsByCategory(category)"
        :key="booth._id"
      >
        <a :href="booth.vendorUrl" target="_blank">
          <img
            :src="getBoothLogo(booth)"
            :alt="booth.vendorName"
            v-if="getBoothLogo(booth)"
          />
          <div v-else class="vendor-name">{{ booth.vendorName }}</div>
        </a>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {};
  },

  methods: {
    removeDuplicatesByCompany(booths) {
      const newBooths = [];
      booths.forEach((booth) => {
        if (!newBooths.find((b) => b.vendorName === booth.vendorName)) {
          newBooths.push(booth);
        }
      });
      return newBooths;
    },
    getBoothsByCategory(category) {
      return this.boothsByCategory[category];
    },
    getBoothLogo(booth) {
      if (booth.logoUrl) {
        return booth.logoUrl;
      }
      if (!booth.logo || !booth.logo._urls) {
        return null;
      }
      return booth.logo._urls["one-half"];
    },
  },

  computed: {
    ...mapGetters(["approvedBooths"]),
    boothsByCategory() {
      const categorizedBooths = this.approvedBooths.reduce((acc, booth) => {
        if (!acc[booth.category]) {
          acc[booth.category] = [];
        }
        acc[booth.category].push(booth);
        return acc;
      }, {});

      const sortedCategories = Object.keys(categorizedBooths).sort();
      const sortedBoothsByCategory = {};

      sortedCategories.forEach((category) => {
        const sortedBooths = categorizedBooths[category].sort((a, b) => {
          if (this.getBoothLogo(a) && !this.getBoothLogo(b)) return -1;
          if (!this.getBoothLogo(a) && this.getBoothLogo(b)) return 1;
          return 0;
        });
        sortedBoothsByCategory[category] = this.removeDuplicatesByCompany(
          sortedBooths
        );
      });

      return sortedBoothsByCategory;
    },
    categories() {
      return Object.keys(this.boothsByCategory);
    },
  },
};
</script>

<style scoped>
.vendor-name {
  height: 80px;
  margin: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
</style>
